import type { ContentStatus } from '@confluence/content-types-header/entry-points/ContentStatus';

import { ContentTypesActionsService } from './content-types-actions-service';
export const contentBoardStatusService = new ContentTypesActionsService<ContentStatus>();
